import { queryBot, queryBot2, queryOne } from 'boot/axios';
import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export class Tasks {
    constructor (app) {
        this.app = app;
        this.error = undefined;
        this.$q = this.app.config.globalProperties.$q;
        this.$db = this.app.config.globalProperties.$db;
        this.context = this.app.config.globalProperties;
    }

    getTask (id) {
        return new Promise((resolve, reject) => {
            const sql = `select * from tasks where id = '${id}' limit 1`;
            queryBot(sql).then((r) => {
                resolve(r.data[0]);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getTasks (filter = '', entryTasks = false, onlyVisible = true) {
        return new Promise((resolve, reject) => {
            if (filter) {
                filter = `where ${filter}`;
            } else {
                filter = ' where (1=1)';
            }
            let vis = '';
            if (onlyVisible) {
                vis = 'and sending_allowed = \'1\'';
            }
            let sql = `select * from tasks ${filter} ${vis} `
                + ' and module_id not in (select id from modules where course_id = tasks.course_id and is_entrance_testing = "1") '
                + ' order by scheduled_date';
            if (entryTasks) {
                sql = `select * from tasks ${filter} ${vis} `
                    + ' and module_id not in (select id from modules where course_id = tasks.course_id and is_entrance_testing = "0") '
                    + ' order by scheduled_date';
            }
            queryBot(sql).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                // this.$q.notify(e);
            });
        });
    }

    getCourses (filter = '') {
        return new Promise((resolve, reject) => {
            if (filter) {
                filter = `where ${filter}`;
            }
            const sql = `select * from courses ${filter} order by title`;
            queryBot(sql).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getModules (filter = '', orderBy = 'title') {
        return new Promise((resolve, reject) => {
            if (filter) {
                filter = `where ${filter}`;
            }
            const sql = `select * from modules ${filter} order by ${orderBy}`;
            queryBot(sql).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getUserCourse (userId, courseId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-course-record', { userId, courseId }).then((r) => {
                resolve(r.data[0]);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getUserCourseInfo (userId, courseId) {
        return new Promise((resolve, reject) => {
            const sql = `select * from user_courses where user_id = ${userId} and course_id = ${courseId}`;
            queryBot(sql).then((r) => {
                resolve(r.data[0]);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getUserCourseFlow (userId, courseId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-course-flow', { userId, courseId }).then((r) => {
                const [row] = r.data;
                resolve(row);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getUserCourseFlowNum (userId, courseId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-flow-num', { userId, courseId }).then((r) => {
                const [row] = r.data;
                resolve(row?.flow_num);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getQuestions (taskId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-task-questions', { taskId }).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getTaskQuestions (filter) {
        return new Promise((resolve, reject) => {
            const sql = `select * from task_questions where ${filter} order by index_number`;
            queryBot(sql).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    isCourseActive (courseId, userId) {
        return new Promise((resolve, reject) => {
            const sql = `select count(*) as count from user_courses where course_id = ${courseId} and user_id = ${userId}`;
            queryBot(sql).then((r) => {
                const row = r.data[0];
                if (row && row.count > 0) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    startCourseAutoFlow (courseId, userId) {
        // eslint-disable-next-line consistent-return,no-async-promise-executor
        return new Promise(async (resolve) => {
            const currentFlow = await this.getActiveFlow(this.context, courseId);
            if (!currentFlow) {
                resolve(false);
                return;
            }
            await queryBot(`update users set last_course_id = '${courseId}' where id = '${userId}'`);
            await this.startCourse(courseId, userId, currentFlow.id);
            resolve(true);
        });
    }

    startCourse (courseId, userId, flowId) {
        return new Promise((resolve, reject) => {
            queryBot2('insert-user-course', { courseId, userId, flowId }).then((r) => {
                resolve(r);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    removeAnswers (userId, taskId) {
        return new Promise((resolve, reject) => {
            const sql = `delete from user_answers where user_id = '${userId}' and task_id = '${taskId}'`;
            queryBot(sql).then(() => {
                resolve();
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    async insertAnswer (userId, taskId, question, answer, lastCourseId) {
        let answersIds = null;
        const { type } = question.question;
        if (['chat', 'options', 't-poll-single'].includes(type)) {
            try {
                answersIds = JSON.parse(answer)?.id || null;
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        if (['t-poll-multi'].includes(type)) {
            try {
                const ids = [];
                JSON.parse(answer).forEach(a => {
                    if (!a?.id) return;
                    ids.push(a.id);
                });
                answersIds = ids?.length ? ids.join(', ') : null;
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        const { result, duration } = question;
        return new Promise((resolve, reject) => {
            queryBot2('add-user-answer-3', {
                taskId,
                userId,
                questionId: question.id,
                type,
                answer,
                answerId: answersIds,
                result,
                lastCourseId,
                duration: duration || null,
            }).then(() => {
                resolve();
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    hasAnswers (userId) {
        return new Promise((resolve, reject) => {
            // const sql = `select count(*) as count from user_answers where user_id = '${userId}'`;
            queryBot2('get-user-answers-count', { userId }).then((r) => {
                resolve(+r.data[0].count > 0);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    getAnswers (userId, taskId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-task-answers', { userId, taskId }).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    removeCompletedTask (taskId, userId) {
        return new Promise((resolve, reject) => {
            queryBot2('remove-compl-tasks', { taskId, userId }).then(() => {
                resolve();
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    async insertCompletedTask (taskId, userId, result, score, context) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            // SELECT * FROM completed_tasks ct INNER JOIN (SELECT task_id, user_id FROM completed_tasks GROUP BY task_id, user_id HAVING COUNT(id) > 1) dup ON ct.task_id = dup.task_id and ct.user_id = dup.user_id
            await this.removeCompletedTask(taskId, userId);
            queryBot2('insert-compl-task', {
                taskId, chatId: userId, result, score,
            }).then(() => {
                context.$db.users.updateStars(userId);
                context.$db.users.updateStarsForCourse(taskId, userId);
                resolve();
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    async skipTask (taskId, userId) {
        await this.removeCompletedTask(taskId, userId);
        return new Promise((resolve, reject) => {
            const sql = 'insert into completed_tasks ( '
                + 'task_id, '
                + 'user_id, '
                + 'is_skipped '
                + ') values ( '
                + `'${taskId}', `
                + `'${userId}', `
                + '"1" '
                + ') ';
            queryBot(sql).then(() => {
                resolve();
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getTaskCompleted (taskId, chatId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-completed-tasks2', { taskId, chatId }).then((response) => {
                resolve(response.data[0]);
            }).catch((err) => {
                console.error(err);
                reject(err.toString());
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getTaskCompletedAll (chatId, courseId) {
        return new Promise((resolve, reject) => {
            queryBot2('get-user-completed-tasks', { chatId, courseId }).then((response) => {
                resolve(response.data);
            }).catch((err) => {
                console.error(err);
                reject(err.toString());
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getPrevTask (courseId, taskScheduledDate) {
        return new Promise((resolve, reject) => {
            const sql = `SELECT * FROM tasks WHERE course_id = ${courseId} and scheduled_date < '${taskScheduledDate}' and sending_allowed = 1 `
                + ' and module_id not in (select id from modules where course_id = tasks.course_id and is_entrance_testing = "1") '
                + ' order by scheduled_date desc '
                + ' limit 1';
            queryBot(sql).then((response) => {
                resolve(response.data);
            }).catch((err) => {
                console.error(err);
                reject(err.toString());
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getUncompletedTasks (fromTaskNum, chatId) {
        return new Promise((resolve, reject) => {
            const sql = 'SELECT * FROM `tasks` WHERE '
                + `num < ${fromTaskNum} and `
                + 'description is not null '
                + 'and description <> "" '
                + 'and sending_allowed = 1 '
                + `and id not in (select task_id from completed_tasks where user_id = '${chatId}')`;
            queryBot(sql).then((response) => {
                resolve(response.data);
            }).catch((err) => {
                console.error(err);
                reject(err.toString());
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getTelegramTaskMessageId (taskId, chatId) {
        return new Promise((resolve, reject) => {
            queryBot(`select start_message_id from sent_tasks_log where task_id = '${taskId}' and chat_id = '${chatId}'`).then((response) => {
                if (response && response.data && response.data.length > 0) {
                    resolve(response.data[0].start_message_id);
                }
            }).catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getCoursePrices (courseId) {
        return new Promise((resolve, reject) => {
            queryBot(`select * from courses_price where course_id = '${courseId}' order by tariff`).then((response) => {
                resolve(response.data);
            }).catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getCoursePrice (courseId) {
        return new Promise((resolve, reject) => {
            queryBot(`select * from courses_price where course_id = '${courseId}' order by tariff limit 1`).then((response) => {
                const [row] = response.data;
                resolve(row ? row.price : 0);
            }).catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }

    getSubscriptions (filter = '') {
        return new Promise((resolve, reject) => {
            if (filter) {
                filter = `where ${filter}`;
            }
            const sql = `select * from subscriptions ${filter} order by title`;
            queryBot(sql).then((r) => {
                resolve(r.data);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    static locateCourseId (alias) {
        return new Promise((resolve, reject) => {
            queryBot2('get-course-id-by-alias', { alias }).then((response) => {
                const d = response.data[0];
                if (d) {
                    resolve(d.id);
                } else {
                    resolve();
                }
            }).catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    async getActiveFlow (context, courseId) {
        let currentFlowNum = 0;
        await queryBot2('get-current-flow-num', { courseId }).then((r) => {
            const [row] = r.data;
            if (row) {
                currentFlowNum = row.current_flow_num || 0;
            }
        });

        let flows;
        await queryBot2('get-course-flows', { courseId, currentFlowNum }).then((r) => {
            flows = r.data;
        });
        if (flows.length === 0) {
            return undefined;
        }

        let flow;
        for (let i = 0; i < flows.length; i += 1) {
            const f = flows[i];
            // убрал ограничение на количество людей на потоке, часто в конфиге ошшибка и поток не выбирается
            // eslint-disable-next-line no-await-in-loop
            // const flowUsersCount = await context.$db.tasks.getFlowUsersCount(courseId, f.id);
            flow = f;
            break;
            /*
            if (+flowUsersCount < +f.max_users) {
                flow = f;
                break;
            }
            */
            /*
            if (+currentFlowNum > 0) {
                if (f.flow_num === currentFlowNum) {
                    flow = f;
                    break;
                }
            } else {
                // eslint-disable-next-line no-await-in-loop
                const flowUsersCount = await context.$db.tasks.getFlowUsersCount(courseId, f.id);
                if (+flowUsersCount < +f.max_users) {
                    flow = f;
                    break;
                }
            }
            */
            // const flowStartsOn = moment(f.starts_on);
            /*
            if (now.isSameOrAfter(flowStartsOn)) {
                // Проверить - если на этом потоке закончились свободные места - то не записывать на него
                // eslint-disable-next-line no-await-in-loop
                const flowUsersCount = await context.$db.tasks.getFlowUsersCount(courseId, f.id);
                console.log('flowUsersCount:', flowUsersCount);
                if (+flowUsersCount < +f.max_users) {
                    flow = f;
                    console.log('flow:', flow);
                    break;
                }
            }
             */
        }
        if (!flow) {
            [flow] = flows;
        }
        if (+currentFlowNum !== +flow.flow_num) {
            queryBot(`update courses set current_flow_num = '${flow.flow_num}' where id = '${courseId}'`);
        }

        return flow;
    }

    // eslint-disable-next-line class-methods-use-this
    async getFlowUsersCount (courseId, flowId) {
        let count = 0;
        const sql = `select count(*) as count from user_courses where flow_id = '${flowId}' and course_id = '${courseId}'`;
        await queryBot(sql).then((r) => {
            count = r.data[0].count;
        });
        return count;
    }

    // eslint-disable-next-line class-methods-use-this
    async getFlow (flowId) {
        let flow;
        await queryBot2('get-flow-by-id', { flowId }).then((r) => {
            [flow] = r.data;
        });
        return flow;
    }

    // eslint-disable-next-line class-methods-use-this
    async getFlowIdByNum (courseId, flowNum) {
        let id;
        await queryBot2('get-flow-id-by-num', { courseId, flowNum }).then((r) => {
            const [row] = r.data;
            if (row) {
                id = row.id;
            }
        });
        return id;
    }

    // eslint-disable-next-line class-methods-use-this
    async getCoursesTags () {
        const tags = [];
        const sql = 'select tags from courses where tags is not null';
        await queryBot(sql).then((r) => {
            const { data } = r;
            data.every((d) => {
                if (!d.tags) {
                    return true;
                }
                const arr = d.tags.split(',').map((i) => i.trim());
                arr.every((a) => {
                    if (!tags.includes(a)) {
                        tags.push(a);
                    }
                    return true;
                });
                return true;
            });
        });
        return tags;
    }

    // eslint-disable-next-line class-methods-use-this
    async getCourseFlows (courseId) {
        let flows = [];
        const sql = `select * from flows where course_id = '${courseId}' order by flow_num`;
        await queryBot(sql).then((r) => {
            flows = r.data;
        });
        return flows;
    }

    // eslint-disable-next-line class-methods-use-this
    async hasTaskNumbers (userId, moduleId) {
        let result = false;
        await queryBot2('get-user-has-task-numbers', { userId, moduleId }).then((r) => {
            const [row] = r.data;
            if (row) {
                const { count } = row;
                result = count > 0;
            }
        });
        return result;
    }

    // eslint-disable-next-line class-methods-use-this
    async updateTaskNumber (userId, moduleId, taskId, number) {
        await queryBot2('update-tasks-numbers', {
            userId, moduleId, taskId, number,
        });
    }

    // eslint-disable-next-line class-methods-use-this
    async getSupermoduleTasks (courseId, moduleId) {
        let modulePosIndex = 0;
        let prevPosIndex = 0;
        let moduleIds = '';
        await queryBot2('get-modules-pos-index', { moduleId }).then((r) => {
            const [row] = r.data;
            if (row) {
                modulePosIndex = row.pos_index;
            }
        });
        await queryBot2('get-modules-before', { modulePosIndex, courseId }).then((r) => {
            const [row] = r.data;
            if (row) {
                prevPosIndex = row.pos_index;
            }
        });
        await queryBot2('get-modules-ids-sm', { courseId, prevPosIndex, modulePosIndex }).then((r) => {
            const [row] = r.data;
            if (row) {
                moduleIds = row.moduleIds;
            }
        });
        const { data } = await queryBot2('get-modules-tasks', { moduleIds, courseId });
        return data;
    }

    saveUserSupermoduleProgress (userId, courseId, superModuleNum, totalTasks, doneTasks) {
        return new Promise((resolve, reject) => {
            const progress = ((+doneTasks * 100) / +totalTasks).toFixed(0);
            queryBot2('insert-user-sm-progress', {
                userId, courseId, superModuleNum, totalTasks, doneTasks, progress,
            }).then((r) => {
                resolve(r);
            }).catch((e) => {
                this.error = e;
                reject(e.toString());
                this.$q.notify(e);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    async removeTelegramNotifications (taskId, fixedFlow = null) {
        await queryBot(`delete from tasks_tg_alerts where taskId = '${taskId}' ${fixedFlow ? `and flowId = ${fixedFlow}` : ''}`);
    }

    // eslint-disable-next-line class-methods-use-this
    async createTelegramNotifications (taskId, fixedFlow = undefined, overrideDate = undefined) {
        let firstTask;
        let task;
        let flows;
        await queryBot(`select id, course_id, scheduled_date from tasks where id = '${taskId}'`).then((r) => {
            [task] = r.data;
        });
        if (!task) { return; }
        // select id, flow_num, starts_on from flows where course_id = '${task.course_id}'
        await queryBot(`
            select flows.id, flows.flow_num, flows.starts_on, tasks_flows_dates.date, tasks_flows_dates.dateShown
            from flows
            left join tasks_flows_dates
            on tasks_flows_dates.courseId = flows.course_id
            and tasks_flows_dates.taskId = '${taskId}'
            and tasks_flows_dates.flows = flows.flow_num
            where flows.course_id = '${task.course_id}'
        `).then((r) => {
            flows = r.data;
        });
        // получить первую тему (исключая вход диаг)
        const sql = `select id, scheduled_date from tasks where course_id = '${task.course_id}' and sending_allowed = '1' `
            + ' and module_id not in (select id from modules where course_id = tasks.course_id and is_entrance_testing = "1") '
            + ' order by scheduled_date';
        await queryBot(sql).then((r) => {
            [firstTask] = r.data;
        });

        if (fixedFlow) {
            let flowId;
            await queryBot(`select id from flows where course_id = '${task.course_id}' and flow_num = '${fixedFlow}'`).then((r) => {
                flowId = r.data[0]?.id;
            });
            const m = moment(overrideDate);

            // if (m.isBefore(moment())) return;

            const notifyAt = m.format('YYYY-MM-DD HH:mm');
            const notification = {
                notifyAt,
                taskId,
                flowId,
                courseId: task.course_id,
            };

            const { data } = await queryBot(`select id from tasks_tg_alerts where courseId = '${task.course_id}' and taskId = '${taskId}' and flowId = '${flowId}' and notifyAt = '${notifyAt}'`);
            if (!data?.length) {
                await this.removeTelegramNotifications(taskId, flowId);
                await this.context.$db.insertObject('tasks_tg_alerts', notification);
            }
            return;
        }

        const firstTaskDate = moment(firstTask.scheduled_date).set({ hour: 0, minute: 0, second: 0 });

        for (let i = 0; i < flows.length; i += 1) {
            const flow = flows[i];
            const flowId = flow.id;
            const startsOn = moment(flow.starts_on).set({ hour: 0, minute: 0, second: 0 });
            const deltaDays = startsOn.diff(firstTaskDate, 'days');
            const m = flow.date ?? moment(task.scheduled_date)
                .add(deltaDays, 'days');

            // if (m.isAfter(moment())) {
            const notifyAt = m.format('YYYY-MM-DD HH:mm');

            const notification = {
                notifyAt,
                taskId,
                flowId,
                courseId: task.course_id,
            };

            await this.removeTelegramNotifications(taskId, flowId);
            await this.context.$db.insertObject('tasks_tg_alerts', notification);
            // }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    async loadTaskDates (tasks, flowNum, courseId) {
        const flow = await queryOne(`select * from flows where flow_num = '${flowNum}' and course_id = '${courseId}'`);
        if (!flow) {
            return tasks;
        }
        const flowStartDate = moment(flow.starts_on).set({ hour: 0, minute: 0, second: 0 });

        const [firstTask] = tasks;

        let deltaDays = 0;
        if (firstTask) {
            const taskDate = moment(firstTask.scheduledDateOriginal || firstTask.scheduled_date).set({ hour: 0, minute: 0, second: 0 });
            deltaDays = flowStartDate.diff(taskDate, 'days');
        }
        for (let i = 0; i < tasks.length; i += 1) {
            const task = tasks[i];
            if (!task.fixedDate) {
                if (!task.scheduledDateOriginal) {
                    task.scheduledDateOriginal = task.scheduled_date;
                }
                if (!task.scheduledDateShownOriginal) {
                    task.scheduledDateShownOriginal = task.scheduled_date_shown;
                }
                task.scheduled_date = task.scheduledDateOriginal;
                task.scheduled_date_shown = task.scheduledDateShownOriginal;
                const taskDate = moment(task.scheduled_date);
                task.scheduled_date = taskDate.add(deltaDays, 'days')
                    .format('YYYY-MM-DD HH:mm');
                if (task.scheduled_date_shown) {
                    const taskDateShown = moment(task.scheduled_date_shown);
                    task.scheduled_date_shown = taskDateShown.add(deltaDays, 'days')
                        .format('YYYY-MM-DD HH:mm');
                }
            }
        }
        return tasks.sort((a, b) => moment(a.scheduled_date) - moment(b.scheduled_date));
    }

    // eslint-disable-next-line class-methods-use-this
    async getCourseModulesCount (courseId) {
        const row = await queryOne(`select count(*) as cnt from modules where course_id = '${courseId}' and is_supermodule = '1'`);
        return row?.cnt || 0;
    }

    // Обновить связь супермодулей и тем курса
    // eslint-disable-next-line class-methods-use-this
    async updateCourseTasksSupermodulesLinks (courseId) {
        if (!courseId) { return; }
        let replaceModules = [];
        // Получим список замененных модулей
        await queryBot(`select * from modules where (course_id = ${courseId} and masterModuleId is not null) order by pos_index`).then((r) => {
            replaceModules = [].concat(r.data);
        });

        let modules = [];

        const sql = `select * from modules where course_id = ${courseId} and masterModuleId is null order by pos_index`;
        await queryBot(sql).then((r) => {
            const mm = [].concat(r.data);
            for (let i = 0; i < mm.length; i += 1) {
                const [replaceModule] = replaceModules.filter((j) => j.masterModuleId === mm[i].id);
                if (replaceModule) {
                    mm[i] = replaceModule;
                }
            }

            const noModule = {
                title: 'Без раздела',
                id: undefined,
            };
            modules = [noModule].concat(mm);
            modules = modules.map((a) => Object.assign(a, { expanded: false }));
        });

        let tasks;

        await queryBot(`select * from tasks where course_id = ${courseId} order by scheduled_date`).then((r) => {
            tasks = [].concat(r.data);
            tasks = tasks.map((t) => {
                t.scheduledDateOriginal = t.scheduled_date;
                t.scheduledDateOriginalSource = t.scheduled_date;
                t.scheduledDateShownOriginal = t.scheduled_date_shown;
                t.scheduledDateShownOriginalSource = t.scheduled_date_shown;
                return t;
            });
        });

        const filterTasks = (moduleId) => {
            if (!tasks) { return undefined; }
            if (!moduleId) {
                return tasks.filter((t) => !t.module_id);
            }
            return tasks.filter((t) => t.module_id === moduleId);
        };

        const refreshTaskNumsUI = (module) => {
            const tasks2 = filterTasks(module.id);
            module.tasks = tasks2;
            if (tasks2) {
                let taskIndex = 1;
                tasks.every((t) => {
                    t.module = module;
                    if (t.sending_allowed === '1' && t.no_number !== '1') {
                        t.num = taskIndex;
                        taskIndex += 1;
                    } else {
                        t.num = undefined;
                    }
                    return true;
                });
            }
        };

        let index = 1;
        modules.every((m) => {
            if (m.id && m.is_supermodule === '0' && m.isNumerable === '1') {
                m.num = index;
                index += 1;
            } else {
                m.num = undefined;
            }
            refreshTaskNumsUI(m);
            return true;
        });

        const reversed = [].concat(modules).reverse();
        let superModuleId = 0;
        let superModuleNum = 0;
        const supermoduleNums = [];
        const tasksCount = {};
        for (let i = 0; i < reversed.length; i += 1) {
            const m = reversed[i];
            if (m.is_supermodule === '1') {
                superModuleId = m.id;
                superModuleNum = m.superModuleNum;
                if (!supermoduleNums.includes(m.superModuleNum)) {
                    supermoduleNums.push(m.superModuleNum);
                }
            }
            if (m.is_supermodule === '0' && m.is_entrance_testing !== '1') {
                const tasks2 = m.tasks;
                if (tasks2) {
                    for (let j = 0; j < tasks2.length; j += 1) {
                        if (!tasksCount[superModuleNum]) {
                            tasksCount[superModuleNum] = 0;
                        }
                        // пропустить невидимые темы
                        if (tasks2[j].sending_allowed === '1' && tasks2[j].attestation !== '1' && tasks2[j].isFinalAttestation !== '1') {
                            tasksCount[superModuleNum] += 1;
                        }
                        // revert.1
                        // console.log(tasks2[j].title, ' - ', superModuleNum);
                        // eslint-disable-next-line no-await-in-loop
                        await queryBot(`update tasks set superModuleId = '${superModuleId}', superModuleNum = '${superModuleNum}' where id = '${tasks2[j].id}'`);
                    }
                }
            }
        }

        /*
        // обновить кеш user_supermodule_progress
        for (let i = 0; i < supermoduleNums.length; i += 1) {
            const smod = supermoduleNums[i];
            // eslint-disable-next-line no-await-in-loop
            await queryBot(`update user_supermodule_progress set totalTasks = '${tasksCount[smod]}' where courseId = '${courseId}' and superModuleNum = '${smod}'`);
        }
        */
    }
}
